import { render, staticRenderFns } from "./PersonalPlan.vue?vue&type=template&id=14422252&scoped=true"
import script from "./PersonalPlan.vue?vue&type=script&lang=js"
export * from "./PersonalPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14422252",
  null
  
)

export default component.exports